<template>
  <div class="container" v-show="status">
    <div class="wrap">
      <p class="title">心探教练服务规则</p>

      <div class="content">
        <div class="yxl-editor">
          <div class="yxl-editor-article">
            <div v-html="content"></div>
          </div>
        </div>
      </div>
      <div class="operation">
        <span class="disagree" @click="agreement('disagree')">不同意</span>
        <span class="agree" @click="agreement('agree')">同意</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    signType: {
      type: String,
      default: 'user'
    }
  },
  data() {
    return {
      status: false,
      content: ''
    }
  },
  computed: {
    mixinIsApp() {
      const { isYixinliApp, isZiXunApp, isZiXunShiApp } = this.$platform
      return isYixinliApp || isZiXunApp || isZiXunShiApp
    }
  },
  methods: {
    async toggleAgreement() {
      if (!this.content) {
        const loading = this.$loading('正在获取服务协议')
        const {
          data: { code, data }
        } = await axios('https://m.xinli001.com/api_article/info/100469864')
        loading.close()
        if (code === 0) {
          this.content = data.article_content
            .replace(/&lt;/g, '<')
            .replace(/&quot;/g, '"')
            .replace(/&gt;/g, '>')
        }
      }
      this.status = !this.status

      this.$nextTick(() => {
        if (this.status) {
          this.scrollTop =
            document.documentElement.scrollTop ||
            window.pageYOffset ||
            document.body.scrollTop ||
            0
          document.body.style.position = 'fixed'
          document.body.style.width = '100%'
          document.body.style.top = `-${this.scrollTop}px`
          if (this.mixinIsApp) {
            this.$bridge.isPullRefreshEnable({
              enable: 0
            })
          }
        } else {
          document.body.style.position = 'initial'
          document.body.style.height = 'auto'
          window.scrollTo(0, this.scrollTop)
          if (this.mixinIsApp) {
            this.$bridge.isPullRefreshEnable({
              enable: 1
            })
          }
        }
      })
    },
    async agreement(type) {
      if (type === 'agree') {
        let { data: res } = await axios.post(
          `https://m.xinli001.com/psychic-coach/sign-service-agreement.json`,
          {
            sign_type: this.signType
          }
        )
        if (res.code) {
          this.$toast({
            text: res.message
          })
          return
        }
      } else if (this.signType === 'user') {
        this.$toast({
          text: '您未同意心探教练服务规则，无法预约心探教练'
        })
      }
      this.$emit('agreement', type)
      this.toggleAgreement()
    }
  }
}
</script>

<style lang="scss">
.yxl-editor {
  & * {
    box-sizing: border-box;
  }
  a {
    color: #06c;
  }
  img {
    width: auto;
  }
  blockquote {
    margin: 0;
  }
}
</style>

<style lang="scss" scoped>
@import '~lib/scss/functions.scss';

.container {
  position: fixed;
  z-index: $hp_other_modal;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  .wrap {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: pxToRem(30);
    padding: pxToRem(50) pxToRem(30);
    width: pxToRem(500);
  }
  .title {
    font-size: pxToRem(36);
    color: #21252d;
    text-align: center;
    line-height: pxToRem(36);
    font-weight: bold;
  }

  .content {
    font-size: pxToRem(28);
    color: #21252d;
    line-height: pxToRem(48);
    margin: pxToRem(30) 0 pxToRem(44);
    max-height: pxToRem(432);
    overflow-y: scroll;
    word-break: break-all;
    -webkit-overflow-scrolling: touch;
  }

  .operation {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .agree,
    .disagree {
      width: pxToRem(235);
      line-height: pxToRem(80);
      text-align: center;
      font-size: pxToRem(28);
      border-radius: pxToRem(40);
    }
    .agree {
      color: #fff;
      background: #6982fa;
    }
    .disagree {
      width: pxToRem(231);
      line-height: pxToRem(76);
      border: pxToRem(2) solid #6982fa;
      color: #6982fa;
      position: relative;
    }
  }
}
</style>
